import React from 'react';
import Card from './Card';

const AssignmentCard = ({base_url}) => {
  const fields = ['created_date', 'user_id', 'exam_id', 'deadline_date'];
  const endpoint = `${base_url}/assignments`;
  return <Card endpoint={endpoint} fields={fields} />;
};

export default AssignmentCard;